import React, { useEffect, useState } from "react";
import overdue from "../../assets/overdue.jpg";
import working from "../../assets/working.jpg";
import critical from "../../assets/critical.jpg";
import duesoon from "../../assets/duesoon.jpg";
import toast from "react-hot-toast";
import formatDateForApi from "../../common/formatDateForApi";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import InfoTooltip from "../../common/InfoTooltip";
import { filterVehicles } from "./pmsFilters";
import formatDateAndTime from "../../common/formatDateAndTime";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

const PMS = ({
  selectionRange,
  setSelectionRange,
  setSavedAmount,
  cityFilter,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  // const [cityFilter, setCityFilter] = useState("1");
  const [pmsData, setPMSData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("All");
  const [vehicleSearch, setVehicleSearch] = useState("");
  const rowsPerPage = 10;

  const handleCopy = async (text, label) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(String(text));
      toast.success(`${label} copied to clipboard`);
    } catch (err) {
      toast.error(`Failed to copy ${label.toLowerCase()}`);
    }
  };

  const getKpiAPIData = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    // ?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/pms?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setPMSData(data?.dataValues);
        setCurrentPage(1);
        setSavedAmount(data?.dataValues?.metricsSummary?.totalAmountSaved);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    getKpiAPIData();
  }, [cityFilter]);

  const normalizeStatus = (value) =>
    String(value || "")
      .trim()
      .toUpperCase()
      .replace(/[\s_-]+/g, "");

  const allVehicles = pmsData?.vehicle || [];
  const filteredVehicles = filterVehicles(
    allVehicles,
    vehicleSearch,
    statusFilter,
  );

  const totalPages = Math.max(
    1,
    Math.ceil(filteredVehicles.length / rowsPerPage),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedVehicles = filteredVehicles.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter, vehicleSearch]);

  const pmsOverviewData = {
    counts: [
      {
        title: "Overdue",
        value: pmsData?.metricsSummary?.statusCounts?.overdue || 0,
        image: overdue,
        outof: "in 500 - 1000 Km",
        class: "text-red-700",
        bg: "bg-white",
      },
      {
        title: "Working",
        value: pmsData?.metricsSummary?.statusCounts?.working || 0,
        image: working,
        outof: `of ${pmsData?.metricsSummary?.statusCounts?.totalVehicles} total Vehicles`,
        class: "text-green-700",
        bg: "bg-white",
      },
      {
        title: "Critical",
        value: pmsData?.metricsSummary?.statusCounts?.critical || 0,
        image: critical,
        outof: "in 1000 Km",
        class: "text-yellow-700",
        bg: "bg-white",
      },
      {
        title: "Due Soon",
        value: pmsData?.metricsSummary?.statusCounts?.dueSoon || 0,
        image: duesoon,
        outof: "in 500 Km",
        class: "text-black",
        bg: "bg-white",
      },
      {
        title: "Un Serviced",
        value: pmsData?.metricsSummary?.statusCounts?.unserviced || 0,
        image: duesoon,
        outof: "Count",
        class: "text-black",
        bg: "bg-white",
      },
    ],
    countsTwo: [
      {
        title: "Count",
        value:
          pmsData?.metricsSummary?.statusCounts?.working +
            pmsData?.metricsSummary?.statusCounts?.dueSoon +
            pmsData?.metricsSummary?.statusCounts?.overdue +
            pmsData?.metricsSummary?.statusCounts?.critical +
            pmsData?.metricsSummary?.statusCounts?.working || 0,
        outof: "Total PMS entries",
        class: "bg-green-700",
      },
      {
        title: "Total Vehicles",
        value: pmsData?.metricsSummary?.statusCounts?.totalVehicles || 0,
        outof: "Count",
        class: "bg-red-700",
      },
      {
        title: "Cost To Company",
        value: "₹ " + pmsData?.metricsSummary?.totalCostToCompany || 0,
        outof: "PMS Cost",
        class: "bg-purple-700",
      },
      {
        title: "Payment Completed",
        value:
          "₹ " +
            (pmsData?.metricsSummary?.totalCostToCompany -
              pmsData?.metricsSummary?.totalOutstandingBalance) || 0,
        outof: "Paid Invoices",
        class: "bg-green-700",
      },
      {
        title: "Payment Pending",
        value: "₹ " + pmsData?.metricsSummary?.totalOutstandingBalance || 0,
        outof: "Unpaid invoices",
        class: "bg-yellow-700",
      },
    ],
  };

  const handleDownload = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      {loading ? (
        <div className="w-full">
          <DashboardSkeleton />{" "}
        </div>
      ) : (
        <>
          {" "}
          {/* <InfoTooltip
            position="right"
            content={
              <div className="space-y-1 text-xs">
                <p>Next Due KM = Last PMS KM + 10,000</p>
                <p>KM Difference = Present KM − Next Due KM</p>
                <p>Remaining KM = Next Due KM − Present KM</p>
              </div>
            }
          /> */}
          <div className="w-full">
            <div className="self-stretch h-32 inline-flex justify-start items-start gap-5 w-full my-4">
              {pmsOverviewData &&
                pmsOverviewData.counts.map((data, index) => (
                  <div
                    className={`flex-1 p-5 rounded-xl border border-black border-lg outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4 ${data?.bg}`}
                  >
                    <div className="self-stretch inline-flex justify-between items-start">
                      <div className="justify-start text-slate-500 text-xs font-medium font-['Inter'] uppercase">
                        {data?.title}
                      </div>
                      <div className="size-4 relative overflow-hidden">
                        <img src={data?.image} />
                      </div>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1">
                      <div
                        className={`justify-start ${data?.class} text-3xl font-semibold font-['Inter']`}
                      >
                        {data?.value}
                      </div>
                      <div className="justify-start text-slate-400 text-xs font-normal font-['Inter'] leading-4">
                        {data?.outof}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="self-stretch inline-flex justify-start items-start gap-2.5 overflow-hidden w-full my-4">
              {pmsOverviewData &&
                pmsOverviewData.countsTwo.map((data, index) => (
                  <div className="flex-1 p-4 relative bg-white rounded-2xl border-l border-r border-t-[1.60px] border-b border-slate-200 inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
                    <div
                      className={`w-full h-1 left-0 top-0 absolute ${data?.class}`}
                    />
                    <div className="self-stretch justify-start text-slate-500 text-[10px] font-semibold font-['Inter'] tracking-wide">
                      {data?.title}
                    </div>
                    <div className="self-stretch justify-start text-slate-900 text-xl font-bold font-['Inter']">
                      {data?.value}
                    </div>
                    <div className="self-stretch justify-start text-slate-400 text-xs font-normal font-['Inter']">
                      {data?.outof}
                    </div>
                  </div>
                ))}
            </div>
            <div className="self-stretch p-4 my-4 bg-red-600/5 rounded-2xl shadow-[0px_4px_8px_0px_rgba(0,0,0,0.03)] outline outline-2 outline-offset-[-2px] outline-red-300/20 flex flex-col justify-start items-center gap-4">
              <div className="self-stretch justify-start text-red-700 text-base font-bold font-['Inter']">
                PMS Critical :{" "}
                {
                  pmsData?.vehicle?.filter(
                    (item) => item?.status === "CRITICAL",
                  ).length
                }
              </div>
              <div className="flex w-full overflow-x-scroll no-scrollbar">
                <div className="flex gap-4 min-w-max">
                  {pmsData?.vehicle?.filter(
                    (item) => item?.status === "CRITICAL",
                  ).length > 0 ? (
                    pmsData?.vehicle
                      ?.filter((item) => item?.status === "CRITICAL")
                      .map((data, index) => (
                        <div key={index} className="flex-shrink-0">
                          <div className="w-[420px] min-h-[150px] flex-shrink-0 p-4 bg-white rounded-2xl outline outline-2 outline-offset-[-2px] outline-pink-100 flex flex-row items-center justify-between gap-6">
                            <div className="min-w-0 flex-1 flex flex-col gap-2">
                              <div className="text-slate-900 text-xl font-extrabold leading-7 tracking-tight truncate">
                                {data?.registration || "N/A"}
                              </div>

                              <div className="w-full flex flex-row gap-1 min-w-0">
                                <div className="text-slate-400 text-xs font-normal leading-5 truncate">
                                  {data?.model || ""}
                                </div>

                                <div className="text-slate-400 text-xs font-normal leading-5 truncate">
                                  {data?.trans || ""}
                                </div>
                              </div>
                            </div>

                            <div className="flex-shrink-0 flex flex-col items-end gap-1.5 text-right">
                              <div className="text-slate-400 text-xs font-semibold uppercase leading-5">
                                Next Due{" "}
                                <span className="text-slate-500">
                                  {data?.nextDueKm || 0} km
                                </span>
                              </div>

                              <div className="text-rose-500 text-base font-bold leading-6">
                                Present <span>{data?.presentKm || 0} km</span>
                              </div>

                              <div className="text-red-500 text-base font-bold leading-6">
                                Exceed <span>{data?.exceededKm || 0}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                  ) : (
                    <>
                      <h1>No Data Found</h1>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="self-stretch bg-white w-full px-5 py-3 inline-flex justify-between items-center gap-4 flex-wrap">
              <div className="justify-start text-black text-sm font-semibold font-['Inter']">
                FLEET SERVICE STATUS
              </div>
              <div className="flex items-center justify-end gap-3 flex-wrap">
                <input
                  type="text"
                  value={vehicleSearch}
                  onChange={(event) => setVehicleSearch(event.target.value)}
                  placeholder="Search vehicle no"
                  className="px-3 py-2 border border-slate-300 rounded-md text-sm outline-none focus:border-blue-500"
                />
                <div className="size- p-1 bg-slate-100 rounded-lg flex justify-start items-start gap-2">
                  {[
                    { label: "All", value: "All" },
                    { label: "Overdue", value: "Overdue" },
                    { label: "Due Soon", value: "Due Soon" },
                  ].map((tab) => {
                    const active = statusFilter === tab.value;
                    return (
                      <button
                        key={tab.value}
                        type="button"
                        onClick={() => {
                          setStatusFilter(tab.value);
                          setVehicleSearch("");
                        }}
                        className={`px-3 py-1.5 rounded-md flex justify-start items-start ${
                          active ? "bg-blue-800" : ""
                        }`}
                      >
                        <div
                          className={`justify-start text-xs font-semibold font-['Inter'] ${
                            active ? "text-white" : "text-slate-500"
                          }`}
                        >
                          {tab.label}
                        </div>
                      </button>
                    );
                  })}

                  <div
                    title="Download Full Report"
                    className="cursor-pointer"
                    onClick={() => {
                      handleDownload(pmsData?.reportUrl);
                    }}
                  >
                    <DownloadForOfflineIcon />
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch w-full overflow-x-auto bg-white">
              <table className="w-full min-w-[2900px] table-fixed border-collapse text-left">
                {/* ================= HEADER ================= */}
                <thead className="border-y border-slate-200 bg-gray-50">
                  <tr>
                    <th className="w-[140px] px-5 py-3 text-left text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Registration
                    </th>

                    <th className="w-[180px] px-5 py-3 text-left text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Model
                    </th>

                    <th className="w-[100px] px-5 py-3 text-left text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Trans
                    </th>

                    <th className="w-[160px] px-5 py-3 text-left text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      City
                    </th>

                    <th className="w-[180px] px-5 py-3 text-left text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Hub
                    </th>

                    <th className="w-[170px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Last PMS KM
                    </th>

                    <th className="w-[170px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Next Due KM
                    </th>

                    <th className="w-[170px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Present KM
                    </th>

                    <th className="w-[180px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Exceed Kilometer
                    </th>

                    <th className="w-[180px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      KM Remaining
                    </th>

                    <th className="w-[200px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Payment Status
                    </th>

                    <th className="w-[190px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Work Order Id
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Block Start Date
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Block End Date
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Cost To Company
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Billing Amount
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Service Status
                    </th>

                    <th className="w-[160px] px-5 py-3 text-right text-slate-400 text-xs font-semibold font-['Inter'] uppercase whitespace-nowrap">
                      Status
                    </th>
                  </tr>
                </thead>

                {/* ================= BODY ================= */}
                <tbody>
                  {paginatedVehicles.length > 0 ? (
                    paginatedVehicles.map((data, index) => {
                      return (
                        <tr
                          key={`${data?.registration || index}-${index}`}
                          className="border-b border-slate-200 bg-white hover:bg-blue-50"
                        >
                          {/* Registration */}
                          <td className="px-5 py-4">
                            <div className="text-black text-sm font-semibold font-['Inter'] leading-5 inline-flex items-center gap-1.5 whitespace-nowrap">
                              <span>{data?.registration || "-"}</span>

                              {data?.registration && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleCopy(
                                      data?.registration,
                                      "Registration",
                                    )
                                  }
                                  title="Copy Registration"
                                  className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors flex-shrink-0"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      x="8"
                                      y="8"
                                      rx="2"
                                      ry="2"
                                    />
                                    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2-2-2h10c1.1 0 2 .9 2 2" />
                                  </svg>
                                </button>
                              )}
                            </div>
                          </td>

                          {/* Model */}
                          <td className="px-5 py-4 text-left text-[10px] font-medium font-['Inter'] uppercase whitespace-nowrap">
                            {data?.model || "N/A"}
                          </td>

                          {/* Transmission */}
                          <td className="px-5 py-4 text-left text-[10px] font-medium font-['Inter'] uppercase whitespace-nowrap">
                            {data?.trans || "N/A"}
                          </td>

                          {/* City */}
                          <td className="px-5 py-4 text-left text-[10px] font-medium font-['Inter'] uppercase whitespace-nowrap">
                            {data?.cityText || "N/A"}
                          </td>

                          {/* Hub */}
                          <td className="px-5 py-4 text-left text-[10px] font-medium font-['Inter'] uppercase whitespace-nowrap">
                            {data?.hubText || "N/A"}
                          </td>

                          {/* Last PMS KM */}
                          <td className="px-5 py-4 text-right whitespace-nowrap">
                            <span className="inline-flex items-center px-3 py-1.5 rounded-lg bg-gray-50 border border-gray-200 text-sm font-bold text-gray-700">
                              {data?.lastPmsKm || 0} Km
                            </span>
                          </td>

                          {/* Next Due KM */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {data?.nextDueKm || "0"} Km
                          </td>

                          {/* Present KM */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {data?.presentKm || "0"} Km
                          </td>

                          {/* Exceed Kilometer */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {data?.exceededKm || "0"}
                          </td>

                          {/* KM Remaining */}
                          <td className="px-5 py-4 text-right whitespace-nowrap">
                            <span className="inline-flex items-center rounded-lg bg-orange-50 px-3 py-2 border border-orange-100 text-sm font-bold text-orange-700">
                              {data?.kmRemaining || "0 Km"}
                            </span>
                          </td>

                          {/* Payment Status */}
                          <td className="px-5 py-4 text-right whitespace-nowrap">
                            {data?.status === "UNSERVICED" ||
                            data?.lastServiceDetails?.paymentPending ===
                              false ? (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-50 border border-green-200 text-green-600 text-xs font-semibold">
                                <span className="flex items-center justify-center w-4 h-4 rounded-full bg-green-500 text-white text-[10px]">
                                  ✓
                                </span>
                                Completed
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-50 border border-red-200 text-red-600 text-xs font-semibold">
                                <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
                                Pending
                              </span>
                            )}
                          </td>

                          {/* Work Order ID */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {data?.lastServiceDetails?.serviceCode || "N/A"}
                          </td>

                          {/* Block Start Date */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {formatDateAndTime(data?.blockStartDate) || "N/A"}
                          </td>

                          {/* Block End Date */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {formatDateAndTime(data?.blockEndDate) || "N/A"}
                          </td>

                          {/* Cost To Company */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            Rs:{" "}
                            {data?.lastServiceDetails?.billingDetails
                              ?.costToCompany || "0"}
                          </td>

                          {/* Billing Amount */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            Rs:{" "}
                            {data?.lastServiceDetails?.billingDetails
                              ?.billingAmount || "0"}
                          </td>

                          {/* Service Status */}
                          <td className="px-5 py-4 text-right text-black text-sm font-normal font-['Inter'] whitespace-nowrap">
                            {data?.lastServiceDetails?.status || "N/A"}
                          </td>

                          {/* Status */}
                          <td className="px-5 py-4 text-right whitespace-nowrap">
                            <div
                              className={`inline-flex px-2.5 py-1 rounded-md ${
                                data?.status === "WORKING"
                                  ? "bg-green-50"
                                  : data?.status === "UNSERVICED"
                                    ? "bg-red-50"
                                    : "bg-gray-50"
                              }`}
                            >
                              <span
                                className={`text-[10px] font-medium font-['Inter'] uppercase ${
                                  data?.status === "WORKING"
                                    ? "text-green-600"
                                    : data?.status === "UNSERVICED"
                                      ? "text-red-600"
                                      : "text-gray-500"
                                }`}
                              >
                                {data?.status || "N/A"}
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={18}
                        className="px-5 py-6 text-slate-500 text-left"
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="w-full px-5 py-4 border-t border-slate-200 flex items-center justify-between bg-slate-50">
              <div className="text-sm text-slate-500">
                Showing {startIndex + 1}-
                {Math.min(startIndex + rowsPerPage, filteredVehicles.length)} of{" "}
                {filteredVehicles.length}
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(1, prev - 1))
                  }
                  disabled={currentPage === 1}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>
                <span className="text-sm text-slate-600">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  type="button"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                  }
                  disabled={currentPage === totalPages}
                  className="px-3 py-1.5 rounded-md border border-slate-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
            <div className="self-stretch h-16 opacity-0 bg-zinc-300" />
          </div>
        </>
      )}
    </>
  );
};

export default PMS;
